import { PermissionCheckboxCell } from './PermissionCheckboxCell';

// Shared role-column checkbox cells for the access matrices in WebAccessPage
// and MobileAccessTab. Every matrix body row (singleton row and indented child
// row, on both pages) ended with the same `{roles.map(...)}` block: one
// `<td className="px-6 py-3.5 text-center">` per role wrapping a
// <PermissionCheckboxCell>. The four call sites differed only in DATA — which
// roles, how the checked flag is derived (hasPermission vs hasFeature), and
// which toggle fires (togglePermission(role.id, menu.id) vs
// toggleFeature(role.id, feature.key)). Those become the `roles`, `isChecked`,
// and `onToggle` props; the rendered markup is byte-identical to each original
// inline block.
//
// NOTE: this intentionally extracts ONLY the per-role checkbox cells. The
// label `<td>` that precedes them, the row `<tr>`, and the group-header row
// are NOT shared because their class strings genuinely differ between the two
// pages (web's child label is `text-sm pl-4 font-medium text-gray-800` while
// mobile's is `text-sm font-medium text-gray-800 pl-4`, and mobile's group
// header `<td>` carries an extra `colSpan={1}`). Unifying those would change
// one page's rendered DOM, so they are deliberately left inline.
interface RoleLike {
  id: string;
}

interface RoleMatrixCheckboxCellsProps {
  /** The role columns to render a checkbox cell for, in order. */
  roles: RoleLike[];
  /** Returns whether the given role currently has this row's permission/feature. */
  isChecked: (roleId: string) => boolean;
  /** Fired with the role id when that role's checkbox cell is toggled. */
  onToggle: (roleId: string) => void;
}

export function RoleMatrixCheckboxCells({ roles, isChecked, onToggle }: RoleMatrixCheckboxCellsProps) {
  return (
    <>
      {roles.map((role) => {
        const checked = isChecked(role.id);
        return (
          <td key={role.id} className="px-6 py-3.5 text-center">
            <PermissionCheckboxCell
              checked={checked}
              onToggle={() => onToggle(role.id)}
            />
          </td>
        );
      })}
    </>
  );
}

export default RoleMatrixCheckboxCells;
